import { Link } from '@tanstack/react-router';
import { useCallback } from 'react';

import Icon from '@/components/Icon/Icon';
import { Button } from '@/components/ui/button';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { ErrorScreen } from '../ErrorScreen';

export function ServerError() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'component.ServerError',
  });

  const handleRetry = useCallback(() => {
    window.location.reload();
  }, []);

  return (
    <ErrorScreen
      icon={
        <Icon
          iconName="TriangleAlertIcon"
          className="text-error-on-neutral-fill size-10"
        />
      }
      title={t('title')}
      description={t('description')}
      role="alert"
    >
      <Button variant="outline" onClick={handleRetry} size="sm">
        {t('retryButton')}
      </Button>
      <Link to="/">{t('backToHome')}</Link>
    </ErrorScreen>
  );
}
